<svg width="100%" height="40" y="6" xmlns="http://www.w3.org/2000/svg">
  <rect *ngIf="canShowRepeatIndicatorLabel" #repeatIndicatorLabelContainer [attr.x]="repeatIndicatorLabelContainerXPosition" width="100%" height="20" fill="white" rx="4" ry="4" />

  <text *ngIf="canShowRepeatIndicatorLabel" #repeatIndicatorLabel x="100%" y="0" dx="-16" dy="4" class="b2 font-weight-semibold quantity" text-anchor="end" dominant-baseline="hanging" fill="gray">
    {{ getQuantityText() }}
  </text>
</svg>
